<template>
  <div>
    <vs-popup :title="$t(popupTitle)" :active.sync="showModal">
      <form>
        <div class="vx-row mb-2">
          <div class="vx-col w-full">
            <vs-input
              class="inputx mb-4 mt-1"
              v-model="model.name"
              name="brandName"
              :label="$t('FestivalName')"
              v-validate="'required'"
            />
            <span
              class="text-danger text-sm"
              v-show="errors.has('festivalName')"
              >{{ errors.first("festivalName") }}</span
            >
          </div>
        </div>
        <div class="vx-row mb-6">
          <div class="vx-col w-full">
            <label class="vs-select--label datepicker-lb">{{
              $t("StartDate")
            }}</label>
            <date-picker
              v-model="model.startClock"
              type="datetime"
              format="jYYYY-jMM-jDD HH:mm:ss"
              display-format="jYYYY-jMM-jDD HH:mm:ss"
              class="date-picker mb-2"
              :label="$t('StartDate')"
              name="startDate"
              v-validate="{ required: true }"
            />
            <span
              class="text-danger text-sm"
              v-show="errors.has('startDate')"
              >{{ errors.first("startDate") }}</span
            >
          </div>
        </div>
        <div class="vx-row mb-6">
          <div class="vx-col w-full">
            <label class="vs-select--label datepicker-lb">{{
              $t("EndDate")
            }}</label>
            <date-picker
              v-model="model.expireClock"
              type="datetime"
              format="jYYYY-jMM-jDD HH:mm:ss"
              display-format="jYYYY-jMM-jDD HH:mm:ss"
              class="date-picker mb-2"
              :label="$t('EndDate')"
              name="endDate"
              v-validate="{ required: true }"
            />
            <span class="text-danger text-sm" v-show="errors.has('endDate')">{{
              errors.first("endDate")
            }}</span>
          </div>
        </div>
        <vs-button
          type="filled"
          class="float-right mb-4"
          @click.prevent="submitForm"
          :disabled="disabled"
          >{{ $t("Save") }}</vs-button
        >
      </form>
    </vs-popup>
  </div>
</template>

<style lang="scss">
.removeIco {
  float: left !important;
  top: 10px !important;
  left: 10px !important;
}
</style>

<script>
import { mapActions } from "vuex";
import { Validator } from "vee-validate";
import VuePersianDatetimePicker from "vue-persian-datetime-picker";

const dict = {
  custom: {
    festivalName: {
      required: "لطفا نام جشنواره را وارد نمایید.",
    },
    startDate: {
      required: "لطفا تاریخ شروع را انتخاب نمایید.",
    },
    endDate: {
      required: "لطفا تاریخ پایان را انتخاب نمایید.",
    },
  },
};
Validator.localize("fa", dict);
export default {
  name: "saleManagement_Contract_Management_Festivals_ModifyPopup",
  props: {
    show: { default: false },
    model: {
      default: {},
    },
    keywords: {},
  },
  data() {
    return {
      festivalName: "",
      popupTitle: "",
      contractId: this.$route.params.id,
      disabled: false,
    };
  },
  computed: {
    showModal: {
      get: function () {
        return this.show;
      },
      set: function () {
        this.$emit("close");
      },
    },
  },
  methods: {
    ...mapActions({
      createFestival: "festival/create",
      updateFestival: "festival/update",
    }),
    submitForm() {
      this.model.contractId = this.contractId;
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.disabled = true;
          if (this.model.id != null) {
            this.updateFestival(this.model).then(() => {});
            setTimeout(() => {
              this.$emit("finish");
              this.model = {};
              this.$validator.reset();
              this.disabled = false;
            }, 3000);
          } else {
            this.createFestival(this.model).then(() => {
              this.$swal({
                position: "center-center",
                type: "success",
                text: "رکورد مورد‌نظر با موفقیت ثبت شد!",
                showConfirmButton: false,
                timer: 2000,
              }).then(() => {
                setTimeout(() => {
                  this.$emit("finish");
                  this.model = {};
                  this.$validator.reset();
                }, 0);
              });
            });
            this.disabled = false;
          }
        }
      });
    },
  },
  watch: {
    show() {
      if (this.show == true) {
        if (this.model.id) this.popupTitle = "EditFestival";
        else this.popupTitle = "CreateNewFestival";
      }
      this.$validator.reset();
      this.disabled = false;
    },
  },
  components: {
    datePicker: VuePersianDatetimePicker,
  },
};
</script>
